// Language-neutral site configuration: languages, official links, URL slugs.

export const SITE_URL = "https://jenniferlopezofficial.com";

export const DEFAULT_LANG = "en";

export const LANGS = [
  { code: "en", name: "English", native: "English", dir: "ltr" },
  { code: "es", name: "Spanish", native: "Español", dir: "ltr" },
  { code: "tr", name: "Turkish", native: "Türkçe", dir: "ltr" },
  { code: "pt", name: "Portuguese", native: "Português", dir: "ltr" },
  { code: "fr", name: "French", native: "Français", dir: "ltr" },
  { code: "de", name: "German", native: "Deutsch", dir: "ltr" },
  { code: "it", name: "Italian", native: "Italiano", dir: "ltr" },
  { code: "ar", name: "Arabic", native: "العربية", dir: "rtl" },
  { code: "hi", name: "Hindi", native: "हिन्दी", dir: "ltr" },
  { code: "ja", name: "Japanese", native: "日本語", dir: "ltr" },
  { code: "ko", name: "Korean", native: "한국어", dir: "ltr" },
  { code: "zh", name: "Chinese", native: "中文", dir: "ltr" },
];

export const LANG_CODES = LANGS.map((l) => l.code);

export const isValidLang = (code) => LANG_CODES.includes(code);

export const getLang = (code) => LANGS.find((l) => l.code === code) || LANGS[0];

// Ordered list of page keys used across routing, nav and sitemap.
export const PAGE_KEYS = [
  "home",
  "timeline",
  "music",
  "film",
  "style",
  "legacy",
  "about",
  "disclaimer",
  "contact",
  "privacy",
];

// Localized slugs. Non-latin languages (ar/hi/ja/ko/zh) use ascii-safe slugs.
const ASCII = {
  timeline: "timeline",
  music: "music",
  film: "film",
  style: "style",
  legacy: "legacy",
  about: "about",
  disclaimer: "disclaimer",
  contact: "contact",
  privacy: "privacy",
};

export const SLUGS = {
  en: { ...ASCII },
  es: {
    timeline: "cronologia",
    music: "musica",
    film: "cine",
    style: "estilo",
    legacy: "legado",
    about: "acerca-de",
    disclaimer: "aviso-legal",
    contact: "contacto",
    privacy: "privacidad",
  },
  tr: {
    timeline: "zaman-cizelgesi",
    music: "muzik",
    film: "sinema",
    style: "stil",
    legacy: "miras",
    about: "hakkinda",
    disclaimer: "yasal-uyari",
    contact: "iletisim",
    privacy: "gizlilik",
  },
  pt: {
    timeline: "linha-do-tempo",
    music: "musica",
    film: "cinema",
    style: "estilo",
    legacy: "legado",
    about: "sobre",
    disclaimer: "aviso-legal",
    contact: "contato",
    privacy: "privacidade",
  },
  fr: {
    timeline: "chronologie",
    music: "musique",
    film: "cinema",
    style: "style",
    legacy: "heritage",
    about: "a-propos",
    disclaimer: "mentions-legales",
    contact: "contact",
    privacy: "confidentialite",
  },
  de: {
    timeline: "zeitstrahl",
    music: "musik",
    film: "filme",
    style: "stil",
    legacy: "vermaechtnis",
    about: "ueber",
    disclaimer: "haftungsausschluss",
    contact: "kontakt",
    privacy: "datenschutz",
  },
  it: {
    timeline: "cronologia",
    music: "musica",
    film: "cinema",
    style: "stile",
    legacy: "eredita",
    about: "chi-siamo",
    disclaimer: "avviso-legale",
    contact: "contatti",
    privacy: "privacy",
  },
  ar: { ...ASCII },
  hi: { ...ASCII },
  ja: { ...ASCII },
  ko: { ...ASCII },
  zh: { ...ASCII },
};

// Build a relative path for a given language + page key.
export const pathFor = (lang, pageKey) => {
  if (pageKey === "home") return `/${lang}`;
  const slug = (SLUGS[lang] && SLUGS[lang][pageKey]) || ASCII[pageKey];
  return `/${lang}/${slug}`;
};

// Resolve a page key from a slug for a given language.
export const pageKeyFromSlug = (lang, slug) => {
  if (!slug) return "home";
  const map = SLUGS[lang] || ASCII;
  const entry = Object.entries(map).find(([, s]) => s === slug);
  return entry ? entry[0] : null;
};

export const STORAGE_KEY = "jlo_lang";

// Detect the visitor's preferred language: saved choice > browser language > default.
export const detectLang = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && isValidLang(stored)) return stored;
    const navs = (typeof navigator !== "undefined" && (navigator.languages || [navigator.language])) || [];
    for (const n of navs) {
      if (!n) continue;
      const base = n.toLowerCase().split("-")[0];
      if (isValidLang(base)) return base;
    }
  } catch (e) {
    /* ignore */
  }
  return DEFAULT_LANG;
};

export const rememberLang = (code) => {
  try {
    if (isValidLang(code)) localStorage.setItem(STORAGE_KEY, code);
  } catch (e) {
    /* ignore */
  }
};

export const OFFICIAL_LINKS = {
  website: "https://www.jenniferlopez.com/",
  store: "https://store.onthejlo.com/",
  onthejlo: "https://web.onthejlo.com/",
};

export const CONTACT_EMAIL = "contact@jenniferlopezofficial.com";

export const ANALYTICS = {
  gaId: process.env.REACT_APP_GA_ID || "",
  plausibleDomain: process.env.REACT_APP_PLAUSIBLE_DOMAIN || "",
  googleSiteVerification: process.env.REACT_APP_GOOGLE_SITE_VERIFICATION || "",
};
